<template>
    <div class="default-message">
        <h2>Hello ChatGPT !</h2>
        <h1> TODO: HTML for explanation </h1>
    </div>
</template>

<script>

export default {
    data() {
      return {
      };
    },
    methods: {
    },
    components: {
    },
    props: ['appData']
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
